class Tools {
  dateFormatter(date) {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    if (y < 2010) {
      return "-";
    } else {
      return y + "." + m + "." + d;
    }
  }

  autoHideText(text, threshold, isHidden) {
    if (!isHidden) return text;
    if (!text) return "";
    if (text.length < threshold) return text;
    else {
      let result = text.substring(0, threshold - 1);
      result += "...";
      return result;
    }
  }

  //时间戳转换方法    date:时间戳数字
  dateFormat(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return YY + MM + DD + " " + hh + mm + ss;
  }

  supportedVideoFormat(type){
    const list = "video/avi,video/quicktime,video/x-flv,video/mpg,video/mpeg,video/x-msvideo,video/x-ms-wmv,video/x-ms-asf,	application/vnd.rn-realmedia,video/rmvb,video/mkv,video/mp4".split(
      ","
    );
    return list.includes(type);
  }
}

let tools = new Tools();

export default tools;



// WEBPACK FOOTER //
// ./src/util/tools.js